import { Label } from '@/components/ui/label'
import { Button } from '@/components/ui/button'

interface NumImagesPickerProps {
  value: number
  onChange: (v: number) => void
  max: number
}

export function NumImagesPicker({ value, onChange, max }: NumImagesPickerProps) {
  const options = Array.from({ length: max }, (_, i) => i + 1)
  return (
    <div className="flex flex-col gap-1.5">
      <Label>Number of images</Label>
      <div className="flex gap-1.5">
        {options.map((n) => (
          <Button
            key={n}
            size="sm"
            variant={value === n ? 'default' : 'outline'}
            onClick={() => onChange(n)}
            className="text-xs px-3"
          >
            {n}
          </Button>
        ))}
      </div>
    </div>
  )
}
